// Professional card accordion
document.querySelectorAll('.professional-card .card-title').forEach(title => {
  title.addEventListener('click', function() {
    if (this.classList.contains('expanded')) {
      this.classList.remove('expanded');
      slideUp(this.nextElementSibling);
      return;
    }
    
    // Closes all the open cards
    document.querySelectorAll('.professional-card .card-content').forEach(content => {
      slideUp(content);
    });
    document.querySelectorAll('.professional-card .card-title').forEach(title => {
      title.classList.remove('expanded');
    });

    // Opens the current card after close animations complete
    setTimeout(() => {
      this.classList.add('expanded');
      slideDown(this.nextElementSibling);
    }, 300);
  });
});

// Professionals list header accordion
document.querySelectorAll('.professionals-list-header').forEach(header => {
  header.addEventListener('click', function() {
    if (this.classList.contains('expanded')) {
      this.classList.remove('expanded');
      slideUp(this.nextElementSibling);
      return;
    }
    
    // Opens the current card
    this.classList.add('expanded');
    slideDown(this.nextElementSibling);
  });
});

// Helper functions for slide animations
function slideUp(element) {
  element.style.height = element.scrollHeight + 'px';
  element.offsetHeight; // Force reflow
  element.style.transition = 'height 0.3s ease';
  element.style.height = '0';
  element.style.overflow = 'hidden';
  
  setTimeout(() => {
    element.style.display = 'none';
    element.style.height = '';
    element.style.transition = '';
    element.style.overflow = '';
  }, 300);
}

function slideDown(element) {
  element.style.display = 'grid';
  const height = element.scrollHeight + 'px';
  element.style.height = '0';
  element.style.overflow = 'hidden';
  element.style.transition = 'height 0.3s ease';
  
  element.offsetHeight; // Force reflow
  element.style.height = height;
  
  setTimeout(() => {
    element.style.height = '';
    element.style.transition = '';
    element.style.overflow = '';
  }, 300);
}